export const styles = theme => ({
    summary: {
        padding: 0
    },
    details: {
        padding: 0
    },
});
